// extracted by mini-css-extract-plugin
module.exports = {"root":"xRV4X__root","noQuestionAsked":"lf4tU__noQuestionAsked"};